import { normalizeId } from './ids';
export const getClubId = (club) => normalizeId(club);

export const getClubDashboardPath = (club) => {
  const clubId = getClubId(club);
  return clubId ? `/club/${clubId}/dashboard` : '';
};

const getTournamentAdminId = normalizeId;

export const getTournamentAdminDashboardPath = (club, tournamentAdmin) => {
  const clubId = getClubId(club);
  const tournamentAdminId = getTournamentAdminId(tournamentAdmin);

  if (!clubId || !tournamentAdminId) return '';

  return `/club/${clubId}/tournament-admin/${tournamentAdminId}/tournaments`;
};

export const getPlayerManagerDashboardPath = (club, playerManager) => {
  const clubId = getClubId(club);
  const playerManagerId = getTournamentAdminId(playerManager);

  if (!clubId || !playerManagerId) return '';

  return `/club/${clubId}/player-manager/${playerManagerId}/tournaments`;
};

export const getMatchManagerDashboardPath = (club, matchManager) => {
  const clubId = getClubId(club);
  const matchManagerId = getTournamentAdminId(matchManager);

  if (!clubId || !matchManagerId) return '';

  return `/club/${clubId}/match-manager/${matchManagerId}/tournaments`;
};

const getManagerId = normalizeId;

export const getAuctionManagerPath = (club, auctionManager, tournament) => {
  const clubId = getClubId(club);
  const auctionManagerId = getManagerId(auctionManager);
  const tournamentId = getManagerId(tournament);

  if (!clubId || !auctionManagerId || !tournamentId) return '';

  return `/club/${clubId}/auction-manager/${auctionManagerId}/tournaments/${tournamentId}`;
};
